import React from 'react';
import MessageBox from '../../../components/MessageBox';

export default function WinterSaleBanner() {
  return (
    <MessageBox type={'info'}>Spring Sale: upgrade now for less</MessageBox>
  );
}
